import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { ITalkWithUsProps } from './TalkWithUs.types';
import { TalkWithUs } from './TalkWithUs';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props: ITalkWithUsProps = elementAttributesToProps(domNode);

  return Promise.resolve(<TalkWithUs {...props} />);
};

export default rehydrator;
